var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitoMirrorPowerupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.04 15.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#959da1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mirror_pu_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,20a2.56,2.56,0,0,1-.39,0l-4.06-.81A2,2,0,0,1,11,17.2v-6a2,2,0,0,1,1.57-1.93h0l4.07-.85a2,2,0,0,1,1.65.4A2,2,0,0,1,19,10.37V18a2,2,0,0,1-.72,1.52A2,2,0,0,1,17,20ZM12.8,10.35a.89.89,0,0,0-.71.86v6a.9.9,0,0,0,.71.87l4.07.8a.84.84,0,0,0,.73-.18.87.87,0,0,0,.32-.68V10.37a.87.87,0,0,0-.32-.69.9.9,0,0,0-.74-.18Z",
    transform: "translate(-4.98 -4.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.94,16.79h0a1.47,1.47,0,0,0,1.16-1.43V11a.31.31,0,0,0-.36-.29l-.51.11a.75.75,0,0,0-.59.73v5A.24.24,0,0,0,12.94,16.79Z",
    transform: "translate(-4.98 -4.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.53,11a2.21,2.21,0,0,1,1.76-2.17l1.48-.31a.42.42,0,0,0,.33-.4V6.71a1.46,1.46,0,0,0-1.18-1.43L6.73,4A1.46,1.46,0,0,0,5,5.48V16.66a1.46,1.46,0,0,0,1.76,1.43L10,17.4a.63.63,0,0,0,.51-.62Z",
    transform: "translate(-4.98 -4.02)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitoMirrorPowerupLogo);
export default __webpack_public_path__ + "static/media/unito-mirror-powerup-logo.d8ccddb160aae3a065d87aab6c737307.svg";
export { ForwardRef as ReactComponent };